import React from 'react';
import { Facebook, Instagram, Youtube, Mail, Phone } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        


































        
        <div className="border-t border-gray-800 pt-6 text-center text-gray-500 text-sm">
          <p>English Work Sociedade de Ensino Ltda © 2025 - Todos os direitos reservados | CNPJ: 48.620.557/0001-51</p>
        </div>
      </div>
    </footer>);

}